import React, {useEffect, useState} from 'react';
import './App.css';
import {BrowserRouter, Route, Routes, useNavigate} from "react-router-dom";
import CartView from "./Pages/CartView";
import i18n from "./i18n";
import PaymentView from "./Pages/PaymentView";
import PaymentMethod from "./Pages/PaymentMethod";
import PaymentStatus from "./Pages/PaymentStatus";
import '../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {Error404} from "./components/Errors/Error404";
import InternalFrame from "./Pages/InternalFrame";
import {getLang} from "./Helpers/functions";
import * as Sentry from "@sentry/react";
import {BrowserTracing} from "@sentry/tracing";
import { useLogging } from './logging/hooks/useLogging';
import Cliq from './Pages/Cliq';
import SelectPayment from "./Pages/SelectPayment";
import CliqSteps from './Pages/CliqSteps';
import Pending from './components/Status/Pending';
import CartBundleUseFinalize from './Pages/CartBundleUseFinalize';
import PaymentStatusScreen from './components/Screen/PaymentStatusScreen';
import PaymentCheck from './components/PaymentCheck/PaymentCheck';
function App() {

    console.log('v.1.30');
    const [isReady, setIsReady] = useState<boolean>(false)

    useEffect(() => {
        i18n.changeLanguage(getLang())
        setIsReady(true);
    }, [])

    const [cartMessage, setCartMessage] = useState<any>(null)

    /*----------------------------
    *           LOGGING           
    *-----------------------------*/
    useLogging();

    return (
        isReady &&
        <BrowserRouter>
            <Routes>
                <Route path={`${process.env.REACT_APP_PAYMENT_DIR}/select-payment/:memberId/:cartId/:identification`} element={<CartView setCartMessage={setCartMessage}/>}></Route>
                <Route path={`${process.env.REACT_APP_PAYMENT_DIR}/select-payment-method/:memberId/:cartId/:identification`} element={<SelectPayment/>}></Route>
                <Route path={`${process.env.REACT_APP_PAYMENT_DIR}/payment/:paymentSecret`} element={<PaymentView/>}></Route>
                <Route path={`${process.env.REACT_APP_PAYMENT_DIR}/payment/:method/:paymentSecret/:webView?`} element={<PaymentMethod/>}></Route>
                <Route path={`${process.env.REACT_APP_PAYMENT_DIR}/payment/:paymentMethod/:status/:paymentSecret/:cartId`} element={<PaymentStatus/>}></Route>
                {cartMessage && <Route path={`${process.env.REACT_APP_PAYMENT_DIR}/cartBundleUse`} element={<CartBundleUseFinalize message={cartMessage} />}></Route>}
                <Route path={`${process.env.REACT_APP_PAYMENT_DIR}/internalFrame`} element={<InternalFrame/>}></Route>
                <Route path={`${process.env.REACT_APP_PAYMENT_DIR}/cliq/:memberId/:cartId/:identification/:paymentSecret`} element={<Cliq/>}></Route>
                <Route path={`${process.env.REACT_APP_PAYMENT_DIR}/cliq/steps/:memberId/:cartId/:identification/:paymentSecret`} element={<CliqSteps/>}></Route>
                <Route path={`${process.env.REACT_APP_PAYMENT_DIR}/payment/pending/:paymentSecret`} element={<Pending/>}></Route>
                <Route path={`${process.env.REACT_APP_PAYMENT_DIR}/payment/screen/:paymentSecret?/:cartId?/:modelId?`} element={<PaymentStatusScreen/>}></Route>
                <Route path={`${process.env.REACT_APP_PAYMENT_DIR}/payment/transaction/check`} element={<PaymentCheck/>}></Route>
                <Route path={'*'} element={<Error404/>}></Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
